<template>
  <div class="page page__list">
    <search-bar
      @search="keywordChange($event)"
      name=""
      placeholder="输入企业名称、联系人进行查找"
      ref="searchBar"
    />
    <div class="weui-navbar">
      <div
        v-for="item in tabs"
        :key="item.name"
        class="weui-navbar__item"
        :class="{weui_bar__item_on: activeTab == item.name}"
        @click="tabChange(item.name)"
      >
        {{ item.title }}
        <p class="weui-badge" v-if="item.name == 'partner_apply' && newPartners > 0">{{ newPartners }}</p>
      </div>
    </div>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div class="weui-panel weui-panel_access weui-panel_sm" v-for="(item, index) in items" :key="item.id">
        <a class="weui-panel__hd weui-flex" :href="'https://m.qcc.com/search?key=' + (item.partnerEnterprise.name)">
          <p class="weui-flex__item">{{ item.partnerEnterprise.name }}</p>
          <p class="iconfont icon-qichacha text-default"></p>
        </a>
        <div class="weui-panel__bd">
          <div class="weui-media-box weui-media-box_text">
            <router-link
              class="weui-media-box__desc weui-flex"
              :to="'/map/baidu?keywords=' + item.partnerEnterprise.addr">
              <span class="weui-flex__item">{{ item.partnerEnterprise.addr }}</span>
              <i class="iconfont icon-map text-default"></i>
            </router-link>
            <div v-if="activeTab == 'partner'">                    
              <div class="partner-user-box" v-for="i in item.userList" :key="i.id">
                <img class="avatar-url" v-if="i.partnerUserAccount.avatarUrl" :src="i.partnerUserAccount.avatarUrl" />
                <div class="avatar-url" v-else>
                  <span class="iconfont icon-user"></span>
                </div>
                <div class="">{{ i.partnerUserAccount.realname }}</div>
                <div class="vertical"></div>
                <div class="partner-mobile">
                  {{ i.partnerUserAccount.mobile }}
                  <call-mobile :mobile="i.partnerUserAccount.mobile"></call-mobile>
                </div>
              </div>
            </div>
            <div v-if="activeTab == 'partner_apply'">
              <div class="partner-user-box" v-if="item.partnerUserAccount">
                <img class="avatar-url" v-if="item.partnerUserAccount.avatarUrl" :src="item.partnerUserAccount.avatarUrl" />
                <div class="avatar-url" v-else>
                  <span class="iconfont icon-user"></span>
                </div>
                <div class="">{{ item.partnerUserAccount.realname }}</div>
                <div class="vertical"></div>
                <div class="partner-mobile">
                  {{ item.partnerUserAccount.mobile }}
                  <call-mobile :mobile="item.partnerUserAccount.mobile"></call-mobile>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="weui-panel__ft">
          <div class="weui-cell weui-cell_access weui-cell_link">
            <div class="weui-cell__bd" @click="openDetail(index)">查看详情</div>
            <div class="weui-cell__bd" v-if="(activeTab == 'partner_apply') && !(item.category == 10 && item.status == 10)" @click="reply(20, index)">同意</div>
            <div class="weui-cell__bd" v-if="(activeTab == 'partner_apply') && !(item.category == 10 && item.status == 10)" @click="reply(30, index)">拒绝</div>
            <div class="weui-cell__ft" @click="visit(index)">去拜访</div>
          </div>
        </div>
      </div>
    </scroll-list>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    ScrollList,
    CallMobile
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/account/company_partner/list",
      params: {
        keyword: "",
        condition: [],
        onlyPartner: true
      },
      tabs: [
        {
          name: 'partner',
          title: '合作伙伴'
        },
        {
          name: 'partner_apply',
          title: '新伙伴'
        }
      ],
      activeTab: 'partner',
      newPartners: 0
    };
  },
  mounted() {
    this.reqCount();
  },
  methods: {
    keywordChange($event) {
      this.params.keyword = $event;
      this.onSearch()
    },
    tabChange(name) {
      if(name == this.activeTab) return;
      this.activeTab = name;
      if(name == "partner") {
        this.listUrl = "/api/account/company_partner/list";
        this.params.condition = [];
      } else {
        this.listUrl = "/api/account/company_partner_apply/list";
        this.params.condition = JSON.stringify({
          operation: '=',
          type: 'number',
          field: 'status',
          value: 10
        });
      }
      this.onSearch();
    },
    reqCount() {
      this.$loading({
        url: '/api/account/company_partner/count',
        loading: true,
      }).then(res => {
        this.newPartners = res.data[0];
      })
    },
    openDetail(index) {
      let form = this.items[index];
      this.$router.push({
        name: 'Partner',
        params: {
          form
        }
      });
    },
    reply(status, index) {
      const me = this
      let form = Object.assign({}, me.items[index], {
        status
      })
      me.$loading({
        url: '/api/account/company_partner/reply',
        jsonData: form,
        method: 'POST',
        loading: true
      }).then(res => {
        console.log(res)
        me.$weui.toast("回复成功", 2000);
        me.onSearch();
        me.reqCount();
      }).catch(e => {
        me.$weui.topTips(e.message, 3000);
      })
    },
    visit(index) {
      let initData = this.items[index];
      if(this.activeTab == "partner") {
        initData = {
          main: {
            cv_date: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
            cv_custname: initData.partnerEnterprise.name,
            cv_contect: initData.userList[0].partnerUserAccount.realname,
            cv_tel: initData.userList[0].partnerUserAccount.mobile            
          }
        }
      } else {
        initData = {
          main: {
            cv_date: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
            cv_custname: initData.partnerEnterprise.name,
            cv_contect: initData.partnerUserAccount.realname,
            cv_tel: initData.partnerUserAccount.mobile            
          }
        }
      }
      this.$router.push({
        name: 'CrmClientVisitEdit',
        params: {
          initData
        }
      });
    }
  }
};
</script>

<style scoped>
.weui-navbar {
  background: #fff;
  color: #666666;
  padding-left: 15px;
  padding-right: 15px;
  border-bottom: 1px solid #ccc;
}

.weui-navbar__item.weui_bar__item_on {
  background: #fff;
  color: #11c366;
  border-bottom-color: #11c366;
}

.weui-navbar__item {
  border-bottom: 4px solid transparent;
  padding: 6px 0;
}

.weui-navbar:after,
.weui-navbar__item:after {
  content: none;
}

.weui-panel_sm .weui-panel__hd {
  padding: 8px 16px 5px 16px;
}

.text-default {
  color: var(--weui-BTN-DEFAULT-COLOR);
}

.weui-panel_sm .weui-media-box {
  padding: 8px 16px;
}

.weui-panel_sm .weui-media-box__desc {
  padding-top: 0;
}

/* .weui-panel_sm .weui-media-box__info {
  margin-top: 8px;
  padding-bottom: 0;
} */

.weui-panel_sm .weui-media-box, .weui-panel_sm .weui-cell {
  padding: 8px 16px;
}

.weui-panel_sm .weui-cell_link {
  font-size: 14px;
}

.list {
  margin-bottom: 0;
}


.partner-user-box{
  width: 100%;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  font-weight: 400;
  color: #bebebe;
  margin: 5px 0;
  display: flex;
}

.partner-mobile .iconfont {
  color: #07c160;
}

.avatar-url{
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 4px;
  background-color: #f1f3f4;
  text-align: center;
}

.avatar-url .iconfont {
  font-size: 20px;
  color: #5a6375;
}

.vertical {
  width: 1px;
  height: 14px;
  background-color: #bebebe;
  margin: 13px 8px;
}
</style>